<div class="navigation-header">
    <h1>{{'admin.title' | translate}}</h1>
</div>
<div class="container-card d-flex">
    <mat-card class="card" (click)="goToUsers()">
        <mat-card-content class="d-flex">
            <fa-icon size="2x" [icon]="usersIcon"></fa-icon>
            <h1>{{'admin.users.title' | translate}}</h1>
        </mat-card-content>
    </mat-card>
    <mat-card class="card" (click)="goToSettings()">
        <mat-card-content class="d-flex">
            <fa-icon size="2x" [icon]="gearIcon"></fa-icon>
            <h1>{{'admin.settings' | translate}}</h1>
        </mat-card-content>
    </mat-card>
</div>